// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import ContactTypography from "@keller/App/Components/Common/ContactTypography";
import { xIsAuthenticated } from "@keller/App/Store/Selectors/GeneralSelectors";
import { color, xMask } from "@keller/XDL/Utilities";
import React, { FC } from "react";
import { css } from "styled-components";

interface BranchPhoneNumberStyles {
    phoneNumber?: TypographyPresentationProps;
}

const branchPhoneNumberStyles: BranchPhoneNumberStyles = {
    phoneNumber: {
        size: 12,
        weight: "bold",
        color: "primary",
        css: css`
            letter-spacing: 0.5px;
            line-height: 16px;
            margin-right: 60px;

            &:hover {
                color: ${color("common.ui1")};
            }
        `,
    },
};

const styles = branchPhoneNumberStyles;
const BranchPhoneNumber: FC = props => {
    const { phoneNumber, isAuthenticated } = useAppSelector(state => ({
        phoneNumber: getSession(state).pickUpWarehouse?.properties.phoneNumber,
        isAuthenticated: xIsAuthenticated(state),
    }));

    if (!phoneNumber || !isAuthenticated) {
        return null;
    }

    return (
        <ContactTypography type="phone" targetValue={phoneNumber} icon={true} {...styles.phoneNumber}>
            {xMask.phoneNumber(phoneNumber)}
        </ContactTypography>
    );
};

const widgetModule: WidgetModule = {
    component: BranchPhoneNumber,
    definition: {
        group: "Header",
        icon: "input-pipe",
        fieldDefinitions: [],
    },
};

export default widgetModule;
